'use client';

import Script from 'next/script';

export function UsableNetScript() {
    return (
        <Script
            id="usablenet-script"
            strategy="afterInteractive"
            data-testid="usablenet-script"
            src="https://a40.usablenet.com/pt/c/petsmart/cookiestorestart"
            defer
        />
    );
}
